import React from 'react';
import { componentService } from 'js/services/component.service';

export const Shufti = React.lazy(() => import(/* webpackChunkName: "shufti" */ './Shufti'));

componentService.registerPageComponents({ shufti: Shufti });
